/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Lastname2Inputs */

const en_formfields_lastname2 = /** @type {(inputs: Formfields_Lastname2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Formfields_Lastname2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_lastname2 = /** @type {((inputs?: Formfields_Lastname2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Lastname2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_lastname2(inputs)
});
export { formfields_lastname2 as "formFields_lastName" }